if(typeof globalThis.global==='undefined'){globalThis.global=globalThis;}